import styled from '@emotion/styled';
import {
  DatePicker as Picker,
  DatePickerProps,
} from '@kep-ui-kit/ui-components';

export const StyledDatePickerWrapper = styled('div')(
  ({
    theme,
    maxWidth,
    fullWidth,
  }: {
    theme?: any;
    maxWidth?: number;
    fullWidth?: boolean;
  }) => ({
    ...(maxWidth && { maxWidth }),
    input: {
      appearance: 'none',
      WebkitAppearance: 'none',
      MozAppearance: 'textfield',
      fontSize: theme.typography.pxToRem(16),
    },
    '.kepuikit-base-input-root': {
      height: '40px !important',
    },
    '.MuiFormControl-root': {
      ...(fullWidth && { width: '100% !important' }),
    },
    '.MuiPaper-root': {
      marginTop: '6px',
    },
  })
);

interface Props extends DatePickerProps {
  fullWidth?: boolean;
}

export const DatePicker = ({ fullWidth, ...rest }: Props) => {
  return (
    <StyledDatePickerWrapper fullWidth={fullWidth}>
      <Picker {...rest} />
    </StyledDatePickerWrapper>
  );
};
